import axios from 'axios'

export async function getMarketWatch () {
  const response = await axios.get('/marketwatch/my')
  return response
}

export async function searchMarketWatch (scriptName) {
  const response = await axios.get(`/marketwatch/search?scriptName=${scriptName}`)
  return response
}

export async function addMarketWatch (scriptId) {
  const response = await axios.post(`/marketwatch/my`, {
    instrumentToken: scriptId
  }
  )
  return response
}

export async function deleteMarketWatch (scriptName) {
  const response = await axios.delete(`/marketwatch/${scriptName}`)
  return response
}

export async function getMyScripts () {
  const response = await axios.get('/marketwatch/my/scripts')
  return response
}

export async function buysell (object) {
  const response = await axios.post(`/order/buysell`, object
  )
  return response
}

export async function buysellModify (object, orderId) {
  const response = await axios.put(`/order/buysell/${orderId}`, object
  )
  return response
}

export async function buysellBulk (object) {
  const response = await axios.post(`/order/bulk/buysell`, object
  )
  return response
}

export async function getOrders () {
  const response = await axios.get(`/order/my`)
  return response
}

export async function getPositions () {
  const response = await axios.get(`/position/my`)
  return response
}

export async function getHoldings () {
  const response = await axios.get(`/holding/my`)
  return response
}

export async function cancelOrders (object) {
  const response = await axios.put(`/order/bulk/cancel`, object
  )
  return response
}

export async function getUserView () {
  const response = await axios.get('/user/my')
  return response
}

export async function getNotification () {
  const response = await axios.get('/user/notification')
  return response
}

export async function signUp (object) {
  const response = await axios.post(`/auth/signup`, object
  )
  return response
}

export async function signUpValid (object) {
  const response = await axios.post(`/auth/signup/valid`, object
  )
  return response
}
export async function authGoogle (object) {
  const response = await axios.post(`/auth/google/auth`, object
  )
  return response
}

export async function signIn (object) {
  const response = await axios.post(`/auth/signin`, object
  )
  return response
}

export async function resend (object) {
  const response = await axios.post(`/auth/signup/otp`, object
  )
  return response
}

export async function userresend (object) {
  const response = await axios.post(`/auth/signin/forgot/otp`, object
  )
  return response
}

export async function forgotPassword (object) {
  const response = await axios.post(`/auth/signin/forgot`, object
  )
  return response
}

export async function changePassword (object) {
  const response = await axios.post(`/user/changepassword`, object
  )
  return response
}

export async function feedback (object) {
  const response = await axios.post(`/user/feedback`, object
  )
  return response
}

export async function track (object) {
  const response = await axios.post(`/user/track`, object
  )
  return response
}

export async function getReport (month, year) {
  const response = await axios.get(`/report/monthly/${month}/${year}`
  )
  return response
}

export async function getPricePlan (type) {
  const response = await axios.get(`/transaction/pricePlans/${type}`
  )
  return response
}

export async function createOrder (data) {
  const response = await axios.post(`/transaction/generateOrder`, data
  )
  return response
}

export async function transaction (data) {
  const response = await axios.post(`/transaction/transactionOrder`, data
  )
  return response
}

export async function getPosReport (date) {
  const response = await axios.get(`/report/monthly/day/${date}`
  )
  return response
}

export async function getChart (measurment, time) {
  const response = await axios.get(`/chart/${measurment}/${time}`
  )
  return response
}

export async function refresh (object) {
  const response = await axios.post(`/auth/refresh`, object
  )
  return response
}

export async function getMonthlyShareLink (month, year) {
  const response = await axios.get(`/share/report/monthly/${month}/${year}`
  )
  return response
}

export async function getMonthlySharedReport (uuid) {
  const response = await axios.get(`/share/report/megabull/monthly?uuid=${uuid}`
  )
  return response
}

export async function getVirtualReport (start, end) {
  const response = await axios.get(`/report/virtual/${start}/${end}`
  )
  return response
}



// WEBPACK FOOTER //
// ./src/service/restService.js